import { Col, Divider, Form, Input, Row, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import TextComponent from '@sharedComponent/typography/TextComponent';
import { images } from 'src/assets/img';

const LocationList = ({
	onAtmClick,
	atmlocationData,
	data,
	isAtmLoading,
	rakbankAtm,
	c3atm,
	selectedEmirate,
	setIsMapEnabled,
	setIsLocation,
	setatmData,
	nodata,
	setNodata,
	locationData,
	setLocationData,
}) => {
	const [atmListOn, setAtmListOn] = useState(true);
	useEffect(() => {
		let temp = c3atm || rakbankAtm;
		setAtmListOn(temp);
	}, [c3atm, rakbankAtm]);
	useEffect(() => {
		if (rakbankAtm && !c3atm) {
			let temp = atmlocationData.filter((data) => data.atmType === 'RAKBANK');
			setLocationData(temp);
		} else if (!rakbankAtm && c3atm) {
			let temp = atmlocationData.filter((data) => data.atmType == 'C3Pay');
			setLocationData(temp);
		} else if (rakbankAtm && c3atm && selectedEmirate == undefined) {
			setLocationData(atmlocationData);
		} else {
			setLocationData(atmlocationData);
		}
	}, [atmlocationData, c3atm, rakbankAtm, selectedEmirate]);
	useEffect(() => {
		if (selectedEmirate && c3atm && !rakbankAtm && selectedEmirate.toLowerCase() !== 'allemirates') {
			let temp = atmlocationData.filter(
				(data) => data.emirate.toLowerCase().replaceAll(' ', '') === selectedEmirate.toLowerCase() && data.atmType != 'RAKBANK'
			);
			setLocationData(temp);
		} else if (selectedEmirate && rakbankAtm && !c3atm && selectedEmirate.toLowerCase() !== 'allemirates') {
			let temp = atmlocationData.filter(
				(data) => data.emirate.toLowerCase().replaceAll(' ', '') === selectedEmirate.toLowerCase() && data.atmType === 'RAKBANK'
			);

			setLocationData(temp);
		} else if (selectedEmirate && !rakbankAtm && !c3atm && selectedEmirate.toLowerCase() !== 'allemirates') {
			let temp = atmlocationData.filter((data) => data.emirate.toLowerCase().replaceAll(' ', '') === selectedEmirate.toLowerCase());

			setLocationData(temp);
		} else if (selectedEmirate && rakbankAtm && c3atm && selectedEmirate.toLowerCase() === 'allemirates') {
			// let temp = atmlocationData.filter((data) => data.emirate.toLowerCase().replaceAll(' ', '') === selectedEmirate.toLowerCase());
			setLocationData(atmlocationData);
		} else if (selectedEmirate && rakbankAtm && c3atm && selectedEmirate.toLowerCase() !== 'allemirates') {
			let temp = atmlocationData.filter((data) => data.emirate.toLowerCase().replaceAll(' ', '') === selectedEmirate.toLowerCase());
			setLocationData(temp);
		} else if (selectedEmirate && !rakbankAtm && !c3atm && selectedEmirate !== 'allemirates') {
			let temp = atmlocationData.filter((data) => data.emirate.toLowerCase().replaceAll(' ', '') === selectedEmirate.toLowerCase());
			setLocationData(temp);
		} else if (rakbankAtm && !c3atm) {
			let temp = atmlocationData.filter((data) => data.atmType === 'RAKBANK');
			setLocationData(temp);
		} else if (!rakbankAtm && c3atm) {
			let temp = atmlocationData.filter((data) => data.atmType == 'C3Pay');
			setLocationData(temp);
		} else if (rakbankAtm && c3atm) {
			setLocationData(atmlocationData);
		} else {
			setLocationData(atmlocationData);
		}
	}, [selectedEmirate, c3atm, rakbankAtm, atmlocationData]);
	console.log('testingdude', atmListOn, locationData?.length > 1);
	return (
		<>
			<div className="parent-atm-con-list">
				{isAtmLoading ? (
					<LoadingOutlined
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							fontSize: 50,
							position: 'relative',
							top: '50%',
						}}
					/>
				) : locationData?.length > 0 && atmListOn ? (
					locationData &&
					locationData.map((data, key) => {
						let temp = data.coordinate;
						let coordinates = temp.split(',');
						let isPublic = data.site == 'Not open to public';
						return (
							<>
								<div
									style={{ cursor: 'pointer' }}
									key={key}
									onClick={() => {
										setIsMapEnabled(true);
										setIsLocation(false);
										onAtmClick(parseFloat(coordinates[0]), parseFloat(coordinates[1]));
									}}>
									<div>
										{data.atmType === 'RAKBANK' ? (
											<img src={images.rk} alt="" className="bank-img" />
										) : (
											<img src={images.c3} alt="" className="bank-img" />
										)}
									</div>
									<div>
										<TextComponent className={isPublic ? 'atm-address-notpublic' : 'atm-address'}>
											{!isPublic && data.name}
											{isPublic && `${data.name} (not open to public)`}
										</TextComponent>
									</div>
									<div>
										<TextComponent className="atm-area">{data.emirate}</TextComponent>
									</div>
									<div>
										<TextComponent className="atm-description">{data.location}</TextComponent>
									</div>
									<div className="atm-divider">
										<Divider />
									</div>
								</div>
							</>
						);
					})
				) : locationData?.length < 1 || !atmListOn ? (
					<div className="no-data-text">No result.</div>
				) : (
					''
				)}
			</div>
		</>
	);
};

export default LocationList;
